export const ticketColumns = [
  {
    id: "number",
    label: "Number",
    editable: false,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "subject",
    label: "Subject",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "customer_business_then_name",
    label: "Customer Name",
    editable: false,
    type: "text",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "invoice_contacts",
    label: "Invoice Contacts",
    editable: false,
    sortable: false,
    type: "multiSelect",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "status",
    label: "Status",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "assets",
    label: "Asset Serial",
    editable: false,
    sortable: false,
    type: "multiSelect",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "problem_type",
    label: "Problem Type",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "created_at",
    label: "Created",
    editable: false,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "updated_at",
    label: "Updated",
    editable: false,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  // {
  //   id: "resolved_at",
  //   label: "Resolved",
  //   editable: false,
  //   type: "date",
  //   width: "150",
  //   show: true,
  //   resizable: true,
  // },
  // {
  //   id: "received_at",
  //   label: "Received",
  //   editable: false,
  //   type: "date",
  //   width: "150",
  //   show: true,
  //   resizable: true,
  // },
];
